import { render } from "./BookTypeListView.vue?vue&type=template&id=1e6c6dce&scoped=true"
import script from "./BookTypeListView.vue?vue&type=script&lang=js"
export * from "./BookTypeListView.vue?vue&type=script&lang=js"

import "./BookTypeListView.vue?vue&type=style&index=0&id=1e6c6dce&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e6c6dce"]])

export default __exports__